// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__KjPR_","topBottomGutter":"Layout_topBottomGutter__3rp9x"};